const minLength = 3

export default {
  isValid: function (username) {
    if (!username || username.length < minLength) {
      return false
    }

    return username.match(/[a-zA-Z]/)
  },
  isValidEmail: function (email) {
    const emailRegex = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

    if (!emailRegex.test(email)) {
      return false
    }

    if (email.includes('..')) {
      return false
    }

    // Not a valid email format without @
    const atIndex = email.indexOf('@')
    if (atIndex === -1) {
      return false
    }

    const localPart = email.substring(0, atIndex)
    if (localPart.startsWith('.') || localPart.endsWith('.')) {
      return false
    }

    return true
  },
  sanitize: function (username) {
    return username.replace(/^[^\w]+|[^\w.]|[^\w]+$/g, '')
  }
}
